import React, {Component} from 'react';
import Preload from '../Preload/Preload';
import QuestionOption from '../QuestionOption/QuestionOption';
import Loading from '../Loading/Loading';
import './Question.css';

export default class Question extends Component {

  constructor(props) {
    super(props);
    this.state = {
      options: this.props.options,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      options: nextProps.options,
    })
  }

  render() {
    const {onAnswerClick, aggregatedQuestions, questionText, trackEvent} = this.props;
    const {options} = this.state;
    let imgUrls = [];
    options.map( (o) => {
      return imgUrls.push(o.img);
    });
    return(
      <div className="questionWrapper">
        <div className="questionIntro">
          <h1 className="serif tac fwn">{questionText}</h1>
        </div>
        <Preload
          loadingIndicator={<Loading />}
          images={imgUrls}
          autoResolveDelay={3000}
          onError={this._handleImageLoadError}
          onSuccess={this._handleImageLoadSuccess}
          resolveOnError={true}
          mountChildren={true}
          key={`${questionText}`}
        >
          <div className={`questionOptions ${options.length === 2 ? "twoOptions" : null} ${options.length === 4 ? "fourOptions" : null} ${options.length > 4 ? "plusOptions" : null}`}>
            { options.map( (option, index) => (
              <QuestionOption
                option={option}
                aggregatedQuestions={aggregatedQuestions}
                onAnswerClick={onAnswerClick}
                trackEvent={trackEvent}
                key={`${questionText}-option--${index}`}
                index={index}
                nextQuestion={`/${this.props.questionNumber + 1}`}
                questionNumber={this.props.questionNumber}
              />
            ))}
          </div>
        </Preload>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Question/Question.js